// Used to track page views in Segment.
//
// *Must* be called on every page, so that Segment destinations reached via
// client-side code can fire.
//
// For details of Segment's page call API see:
// https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#page
//
// Name and keywords are reserved properties in Segment. PageType is our own custom property.

import { AnalyticsWindow } from "../window"

type PageViewProps = {
  pageType?: string
  pageName?: string
  keywords?: string[]
}

type SegmentPageViewProperties = {
  pageType?: string
  keywords?: string[]
}

declare let window: AnalyticsWindow

export default function analyticsPageView(
  _: HTMLElement,
  props: PageViewProps,
) {
  if (!window.analytics) return

  // Build custom properties to send to Segment
  let pageViewProperties: SegmentPageViewProperties = {}

  if (props.pageType) {
    pageViewProperties.pageType = props.pageType
  }

  if (props.keywords) {
    pageViewProperties.keywords = props.keywords
  }

  // Send page name in addition to properties when a page name
  // is present, otherwise only send properties
  if (props.pageName) {
    window.analytics.page(props.pageName, pageViewProperties)
  } else {
    window.analytics.page(pageViewProperties)
  }
}
